import React, { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { useI18n } from "../i18n";
import { BRAND } from "../config/plans";
import { Button } from "../components/ui";
import Icon from "../components/ui/Icon";

export const SUPER_MENU = [
  { to: "/su", exact: true, icon: "building", label: "ร้านทั้งหมด", labelEn: "Shops" },
  { to: "/su/sales", icon: "chartBar", label: "ยอดขาย", labelEn: "Sales" },
  { to: "/su/requests", icon: "fileText", label: "คำขอ & ใบเสนอราคา", labelEn: "Requests & quotes" },
  { to: "/su/boosts", icon: "heart", label: "ออเดอร์ปั้ม", labelEn: "Boost orders" },
];

// หน้าทีมงานเจ้าของระบบ (super_user) — ใช้โครงเดียวกับหลังบ้านร้าน หน้าตาตามธีมของเว็บนี้
export default function SuperLayout() {
  const { profile, logout } = useApp();
  const { tx, lang, setLang, pick } = useI18n();
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(false), [location.pathname]);

  const current = SUPER_MENU.filter((item) => (item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to)))
    .sort((a, b) => b.to.length - a.to.length)[0];

  return (
    <div className="crm-shell">
      <aside className={`crm-sidebar ${open ? "is-open" : ""}`}>
        <div className="crm-sidebar__brand">
          <span className="crm-logo">SU</span>
          <div>
            <div>{BRAND.name}</div>
            <div style={{ fontSize: 11, fontWeight: 500, opacity: 0.75 }}>{tx("ทีมงานเจ้าของระบบ", "Platform team")}</div>
          </div>
        </div>
        <div className="crm-sidebar__scroll">
          <div className="crm-sidebar__group">super_user</div>
          {SUPER_MENU.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.exact} className={({ isActive }) => `crm-nav-link ${isActive ? "is-active" : ""}`}>
              <span className="crm-nav-link__icon"><Icon name={item.icon} /></span>
              {pick(item, "label")}
            </NavLink>
          ))}
        </div>
      </aside>

      {open ? <div className="crm-backdrop" onClick={() => setOpen(false)} /> : null}

      <div className="crm-main">
        <header className="crm-topbar">
          <Button className="crm-burger" size="sm" onClick={() => setOpen((v) => !v)}>
            <Icon name="menu" />
          </Button>
          <h2 className="crm-topbar__title">{current ? pick(current, "label") : "super_user"}</h2>
          <div className="crm-topbar__spacer" />
          <span className="u-fs-12 u-muted">{profile?.email}</span>
          <Button size="sm" onClick={() => setLang(lang === "th" ? "en" : "th")}>
            {lang === "th" ? "🇹🇭 ไทย" : "🇬🇧 EN"}
          </Button>
          <Button
            size="sm"
            onClick={async () => {
              await logout();
              navigate("/su/login");
            }}
          >
            <Icon name="logout" /> {tx("ออกจากระบบ", "Log out")}
          </Button>
        </header>
        <main className="crm-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
